/* Waïloa – page d'accueil (sections wl-home-*). JS vanilla, sans dépendance, chargé en defer. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOB = window.matchMedia('(max-width: 749px)');
  var DESK = window.matchMedia('(min-width: 990px)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var hasIO = 'IntersectionObserver' in window;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function loadVideo(v, src) {
    if (!src || v.getAttribute('src') === src) return;
    v.src = src; v.muted = true; v.setAttribute('muted', '');
    v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
  }

  /* Apparitions au défilement */
  /* Les éléments masqués par clip-path sont observés via leur parent (un élément entièrement découpé n'est jamais « visible »). */
  var revealIO = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = (e.target.__wlhT || []).concat([e.target]);
      t.forEach(function (el) { el.classList.add('is-in'); });
      revealIO.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }) : null;
  function initReveal(root) {
    $$('[data-wlh-r],[data-wlh-reveal]', root).forEach(function (el) {
      if (!revealIO || RM.matches) { el.classList.add('is-in'); return; }
      var obs = el.hasAttribute('data-wlh-reveal') ? el.parentElement : el;
      if (obs !== el) { (obs.__wlhT = obs.__wlhT || []).push(el); }
      revealIO.observe(obs);
    });
  }

  /* Hero : hauteur = premier écran sous l'en-tête, vidéo seulement si visible */
  function initHero(root) {
    $$('[data-wlh-hero]', root).forEach(function (hero) {
      function fit() {
        var top = hero.getBoundingClientRect().top + window.pageYOffset;
        hero.style.setProperty('--wlh-top', Math.max(0, Math.min(top, 220)) + 'px');
      }
      /* PERF2 : mesure au prochain rendu (évite un recalcul de mise en page forcé au démarrage) */
      requestAnimationFrame(fit); window.addEventListener('load', function () { requestAnimationFrame(fit); });
      var next = hero.querySelector('[data-wlh-next]');
      if (next) next.addEventListener('click', function () {
        var sec = hero.closest('.shopify-section'); var t = sec && sec.nextElementSibling;
        var y = (t ? t.getBoundingClientRect().top : hero.getBoundingClientRect().bottom) + window.pageYOffset;
        window.scrollTo({ top: y, behavior: RM.matches ? 'auto' : 'smooth' });
      });
      var v = hero.querySelector('video');
      if (!v || RM.matches || saveData) return;
      /* PERF2 (2 oct.) : vidéo jamais chargée sur mobile / tablette (< 990 px) ; sur ordinateur, seulement après l'événement load
         puis un moment de calme du navigateur : l'image du héros reste l'image principale (LCP). */
      if (!DESK.matches) return;
      function attach() { loadVideo(v, v.dataset.srcD); }
      function watch() {
        if (!hasIO) { attach(); playSafe(v); return; }
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { if (e.isIntersecting) { attach(); playSafe(v); } else if (v.src) { v.pause(); } });
        }, { threshold: 0.2 }).observe(hero);
      }
      function later() { if (window.requestIdleCallback) requestIdleCallback(watch, { timeout: 4000 }); else setTimeout(watch, 2000); }
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    });
  }

  /* Rails horizontaux : barre de progression, flèches, compteur */
  function initRail(scope, track) {
    if (!track || track.dataset.wlhOk) return; track.dataset.wlhOk = '1';
    var bar = scope.querySelector('[data-wlh-bar]');
    var prev = scope.querySelector('[data-wlh-prev]');
    var next = scope.querySelector('[data-wlh-next-slide]');
    var cur = scope.querySelector('[data-wlh-cur]');
    var raf = 0;
    function update() {
      raf = 0;
      /* PERF2 : toutes les lectures de mise en page d'abord, les écritures ensuite */
      var sw = track.scrollWidth, cw = track.clientWidth, sl = track.scrollLeft;
      var max = sw - cw;
      var ratio = sw ? cw / sw : 1;
      var p = max > 0 ? sl / max : 0;
      var ci = -1;
      if (cur) {
        var items = track.children, best = Infinity, tl = track.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).paddingLeft) || 0);
        ci = 0;
        for (var k = 0; k < items.length; k++) { var d = Math.abs(items[k].getBoundingClientRect().left - tl); if (d < best) { best = d; ci = k; } }
      }
      if (bar) {
        var w = Math.max(ratio, 0.12) * 100;
        bar.style.setProperty('--w', w + '%');
        bar.style.setProperty('--x', (p * (100 / w - 1) * 100) + '%');
        bar.parentNode.style.visibility = max > 4 ? 'visible' : 'hidden';
      }
      if (prev) prev.disabled = sl <= 4;
      if (next) next.disabled = sl >= max - 4;
      if (cur && ci > -1) cur.textContent = (ci + 1 < 10 ? '0' : '') + (ci + 1);
    }
    function step(dir) {
      var item = track.children[0]; if (!item) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var per = Math.max(1, Math.floor(track.clientWidth / (item.getBoundingClientRect().width + gap)) - 0);
      track.scrollBy({ left: dir * per * (item.getBoundingClientRect().width + gap), behavior: RM.matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', function () { if (!raf) raf = requestAnimationFrame(update); });
    raf = requestAnimationFrame(update); setTimeout(function () { if (!raf) raf = requestAnimationFrame(update); }, 600);
  }

  function initUniverses(root) {
    $$('[data-wlh-uni]', root).forEach(function (s) { initRail(s, s.querySelector('[data-wlh-track]')); });
  }

  /* Produits : onglets */
  function initProducts(root) {
    $$('[data-wlh-prod]', root).forEach(function (s) {
      $$('[data-wlh-rail]', s).forEach(function (r) { initRail(r, r.querySelector('[data-wlh-track]')); });
      var tabs = $$('[role="tab"]', s), all = s.querySelector('[data-wlh-all]');
      function select(t, focus) {
        tabs.forEach(function (b) {
          var on = b === t; b.setAttribute('aria-selected', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls')); if (panel) panel.hidden = !on;
        });
        if (all && t.dataset.url) all.href = t.dataset.url;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) { var tr = p.querySelector('[data-wlh-track]'); if (tr) { tr.scrollLeft = 0; tr.dispatchEvent(new Event('scroll')); } }
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = i === 0 ? 0 : -1;
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = null;
          if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length]; else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  /* Chapitre : compteurs + parallaxe douce */
  function initChapter(root) {
    $$('[data-wlh-chap]', root).forEach(function (s) {
      $$('[data-wlh-count]', s).forEach(function (el) {
        var m = el.textContent.trim().match(/^(\d+)(.*)$/);
        if (!m || RM.matches || !hasIO) return;
        var end = parseInt(m[1], 10), rest = m[2], done = false;
        el.textContent = '0' + rest;
        new IntersectionObserver(function (en, io) {
          en.forEach(function (e) {
            if (!e.isIntersecting || done) return; done = true; io.disconnect();
            var t0 = performance.now(), dur = 1400;
            (function tick(t) { var k = Math.min(1, (t - t0) / dur); k = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(end * k) + rest; if (k < 1) requestAnimationFrame(tick); })(t0);
          });
        }, { threshold: 0.6 }).observe(el);
      });
      var sub = s.querySelector('[data-wlh-parallax]');
      if (!sub || RM.matches || MOB.matches) return;
      var ticking = false;
      function par() {
        ticking = false;
        var r = s.getBoundingClientRect(), vh = window.innerHeight;
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        sub.style.transform = 'translate3d(0,' + (p * -60).toFixed(1) + 'px,0)';
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(par); } }, { passive: true });
      ticking = true; requestAnimationFrame(par);
    });
  }

  /* UGC : lecture auto muette de la carte visible, visionneuse plein écran */
  function initUGC(root) {
    $$('[data-wlh-ugc]', root).forEach(function (s) {
      var track = s.querySelector('[data-wlh-track]');
      initRail(s, track);
      var cards = $$('.wlh-ugc__card.is-video', s);
      var vis = new Map();
      function pick() {
        var best = null, bestR = 0.55;
        vis.forEach(function (r, v) { if (r > bestR) { bestR = r; best = v; } });
        cards.forEach(function (c) {
          var v = c.querySelector('video'); if (!v) return;
          var r = vis.get(v) || 0;
          var play = DESK.matches ? r > 0.55 : v === best;
          if (play && !RM.matches && !saveData) { loadVideo(v, v.dataset.src); playSafe(v); } else if (!v.paused) v.pause();
        });
      }
      if (hasIO && cards.length) {
        var io = new IntersectionObserver(function (en) {
          en.forEach(function (e) { vis.set(e.target, e.isIntersecting ? e.intersectionRatio : 0); });
          pick();
        }, { threshold: [0, 0.3, 0.55, 0.75, 1] });
        cards.forEach(function (c) { var v = c.querySelector('video'); if (v) io.observe(v); });
      }

      var dlg = s.querySelector('[data-wlh-lb]'); if (!dlg) return;
      var lt = dlg.querySelector('[data-wlh-lb-track]');
      var slides = $$('.wlh-lb__slide', dlg);
      var curEl = dlg.querySelector('[data-wlh-lb-cur]');
      var snd = dlg.querySelector('[data-wlh-lb-snd]');
      var idx = 0, sound = false, opener = null;
      function vidOf(i) { return slides[i] && slides[i].querySelector('video'); }
      function activate(i) {
        idx = Math.max(0, Math.min(slides.length - 1, i));
        if (curEl) curEl.textContent = idx + 1;
        slides.forEach(function (sl, k) {
          var v = sl.querySelector('video'); if (!v) return;
          if (k === idx) { loadVideo(v, v.dataset.src); v.muted = !sound; playSafe(v); } else if (!v.paused) v.pause();
          var img = sl.querySelector('img[loading="lazy"]'); if (img && Math.abs(k - idx) <= 1) img.loading = 'eager';
        });
        if (snd) snd.hidden = !vidOf(idx);
      }
      function go(i, smooth) { lt.scrollTo({ left: i * lt.clientWidth, behavior: smooth && !RM.matches ? 'smooth' : 'auto' }); activate(i); }
      function open(i) {
        opener = document.activeElement;
        cards.forEach(function (c) { var v = c.querySelector('video'); if (v && !v.paused) v.pause(); });
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.classList.add('wlh-lock');
        requestAnimationFrame(function () { go(i, false); });
      }
      function close() {
        slides.forEach(function (sl) { var v = sl.querySelector('video'); if (v) v.pause(); });
        if (dlg.open && dlg.close) dlg.close(); else dlg.removeAttribute('open');
      }
      dlg.addEventListener('close', function () {
        slides.forEach(function (sl) { var v = sl.querySelector('video'); if (v) v.pause(); });
        document.documentElement.classList.remove('wlh-lock'); lt.style.transform = ''; lt.style.opacity = '';
        if (opener && opener.focus) opener.focus(); pick();
      });
      $$('[data-wlh-ugc-open]', s).forEach(function (b) { b.addEventListener('click', function () { open(parseInt(b.getAttribute('data-wlh-ugc-open'), 10) || 0); }); });
      dlg.querySelector('[data-wlh-lb-x]').addEventListener('click', close);
      dlg.querySelector('[data-wlh-lb-p]').addEventListener('click', function () { go(idx - 1, true); });
      dlg.querySelector('[data-wlh-lb-n]').addEventListener('click', function () { go(idx + 1, true); });
      if (snd) snd.addEventListener('click', function () {
        sound = !sound; snd.setAttribute('aria-pressed', sound ? 'true' : 'false');
        var v = vidOf(idx); if (v) { v.muted = !sound; playSafe(v); }
      });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) { close(); return; }
        var v = e.target.closest('video'); if (v) { if (v.paused) playSafe(v); else v.pause(); }
      });
      dlg.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1, true); }
      });
      var st = 0;
      lt.addEventListener('scroll', function () {
        clearTimeout(st); st = setTimeout(function () { var i = Math.round(lt.scrollLeft / lt.clientWidth); if (i !== idx) activate(i); }, 90);
      }, { passive: true });
      /* Glisser vers le bas pour fermer */
      var y0 = null, x0 = 0, dy = 0;
      lt.addEventListener('touchstart', function (e) { if (e.touches.length !== 1) return; y0 = e.touches[0].clientY; x0 = e.touches[0].clientX; dy = 0; }, { passive: true });
      lt.addEventListener('touchmove', function (e) {
        if (y0 === null) return;
        var ddy = e.touches[0].clientY - y0, ddx = Math.abs(e.touches[0].clientX - x0);
        if (ddy > 0 && ddy > ddx * 1.2) { dy = ddy; lt.style.transform = 'translateY(' + dy + 'px)'; lt.style.opacity = String(Math.max(0.35, 1 - dy / 500)); }
      }, { passive: true });
      lt.addEventListener('touchend', function () {
        if (y0 === null) return; y0 = null;
        if (dy > 110) close(); else { lt.style.transform = ''; lt.style.opacity = ''; }
      });
    });
  }

  /* Texte SEO repliable sur mobile */
  function initSeo(root) {
    $$('[data-wlh-seo]', root).forEach(function (s) {
      var t = s.querySelector('[data-wlh-seo-t]'), b = s.querySelector('[data-wlh-seo-btn]');
      if (!t || !b) return;
      function check() { b.hidden = !(MOB.matches && (t.classList.contains('is-open') || t.scrollHeight > t.clientHeight + 4)); }
      b.addEventListener('click', function () {
        var open = t.classList.toggle('is-open');
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        b.textContent = open ? b.dataset.less : b.dataset.more;
      });
      requestAnimationFrame(check); window.addEventListener('resize', check);
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root); initHero(root); initUniverses(root); initProducts(root); initChapter(root); initUGC(root); initSeo(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target; if (el && el.scrollIntoView) { var tr = el.closest('[data-wlh-track]'); if (tr) tr.scrollTo({ left: el.offsetLeft - parseFloat(getComputedStyle(tr).paddingLeft), behavior: 'smooth' }); }
  });
})();
